import { render } from "./AppliancesCreate.vue?vue&type=template&id=695f8490&scoped=true"
import script from "./AppliancesCreate.vue?vue&type=script&lang=js"
export * from "./AppliancesCreate.vue?vue&type=script&lang=js"

import "./AppliancesCreate.vue?vue&type=style&index=0&id=695f8490&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695f8490"]])

export default __exports__